export default __webpack_public_path__ + "static/media/blueTrashCan.cbdb5fe3.svg";